export default "__VITE_ASSET__CFS8m9fJ__"